<template>
    <div>
        <vacancy-details :vacancy="activeVacancy"></vacancy-details>
        <vacancy-form :job-position="activeVacancy.position" :policy="policy" :agreement="agreement" :terms="terms" id="formNew">
            <template v-slot:description>
                <div class="col-12 col-md-6 col-lg-6 p-md-2 pr-6">
                    <h2 class="vacancy-form__h2 mb-10">Присоединяйтесь к нашей команде!</h2>
                    <p class="vacancy-form__p">Отдел Карьеры </p>
                    <a href="tel:88005004373" class="d-block vacancy-form__link">8 (800) 500-43-73</a>
                </div>
            </template>
        </vacancy-form>
    </div>

</template>

<script>
import vacancyDetails from "./vacancy_details.vue";
import VacancyForm from "./vacancy_form.vue";


export default {
    name: "vacancyPage",
    components: {VacancyForm, vacancyDetails},
  props: {
      vacancy: Array | Object | String,
      policy: Array | Object | String,
      agreement: Array | Object | String,
      terms: Array | Object | String,
  },
    data() {
        return {
          activeVacancy: this.vacancy,
            /*activeVacancy: {
                city: 'Дзержинск',
                experience: 'От 1 года до 3 лет',
                position: 'Менеджер по исследованиям и структурированию',
                skills: ['Работа в команде', 'Уверенный пользователь Excel', 'Знание 1С'],
                text: 'Наши масштабные проекты улучшают жизнь миллионов. Мы объединяем профессионалов и открываем новые возможности для роста каждого сотрудника.',
                info: [
                    {
                        title: 'Что нужно делать:',
                        list: [
                            ' Механизированная разгрузка/загрузка транспортных средств по количеству ТМЦ согласно отгрузочным документам при помощи аккумуляторных перевозчиков паллет',
                            ' Размещение ТМЦ на складе',
                            ' Комплектация заказов (70% паллетная комплектация, 30% коробочная комплектация)',
                            'Упаковках собранных заказов',
                            'Проведение пересчета ТМЦ в ячейках',
                            'Работа на паллетообмотчике',
                            'Переупаковка ТМЦ в случае необходимости'
                        ],
                    },
                    {
                        title: 'Что готовы предложить:',
                        list: [
                            'Официальное оформление по ТК РФ с первого дня работы, стабильная "белая" заработная плата (выплаты 2 раза в месяц)',
                            ' Размещение ТМЦ на складе',
                            ' Комплектация заказов (70% паллетная комплектация, 30% коробочная комплектация)',
                            'Упаковках собранных заказов',
                            'Проведение пересчета ТМЦ в ячейках',
                            'Работа на паллетообмотчике',
                            'Переупаковка ТМЦ в случае необходимости'
                        ],
                    },
                ]
            },*/
        }
    },
}
</script>

<style scoped>

</style>